import { Controller } from "@hotwired/stimulus"

// Управляет flash-тостами: авто-скрытие через таймаут и ручное закрытие.
export default class extends Controller {
  static targets = ["item"]
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    this.timers = new Map()
    this.itemTargets.forEach((item) => this.scheduleHide(item))
  }

  disconnect() {
    this.timers.forEach((id) => clearTimeout(id))
    this.timers.clear()
  }

  scheduleHide(item) {
    const id = setTimeout(() => this.hide(item), this.timeoutValue)
    this.timers.set(item, id)

    // Пауза таймера при наведении
    item.addEventListener("mouseenter", () => {
      clearTimeout(this.timers.get(item))
    })
    item.addEventListener("mouseleave", () => {
      this.timers.set(item, setTimeout(() => this.hide(item), this.timeoutValue))
    })
  }

  dismiss(event) {
    this.hide(event.currentTarget.closest(".flash"))
  }

  hide(item) {
    if (!item || item.classList.contains("flash--hide")) return
    clearTimeout(this.timers.get(item))
    item.classList.add("flash--hide")
    item.addEventListener("animationend", () => item.remove(), { once: true })
  }
}
